import { render, staticRenderFns } from "./SupplierCreate.vue?vue&type=template&id=6e96f1f4&"
import script from "./SupplierCreate.vue?vue&type=script&lang=js&"
export * from "./SupplierCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports